module.exports = __webpack_public_path__ + "assets/times.f0e53101.svg";